export const isAuth = localStorage.getItem('role') === 'Admin';